import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Alert,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import {
  CheckCircle as CheckIcon,
  Image as ImageIcon
} from '@mui/icons-material';

const ARTWORK_REQUIREMENTS = [
  { id: 'size', label: 'Minimum size: 3000x3000 pixels' },
  { id: 'format', label: 'Format: JPEG or PNG' },
  { id: 'quality', label: 'High color quality' },
  { id: 'design', label: 'Clear, professional design' }
];

const CoverArtwork = ({ coverArt, getCoverRootProps, getCoverInputProps }) => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Cover Artwork
      </Typography>

      <Alert severity="info" sx={{ mb: 3 }}>
        Your cover artwork is crucial for your release's visual identity. Please ensure it meets all requirements.
      </Alert>

      {/* Requirements List */}
      <List>
        {ARTWORK_REQUIREMENTS.map((req) => (
          <ListItem key={req.id}>
            <ListItemIcon>
              {coverArt ? <CheckIcon color="success" /> : <ImageIcon color="disabled" />}
            </ListItemIcon>
            <ListItemText primary={req.label} />
          </ListItem>
        ))}
      </List>

      {/* Upload Area */}
      <Box
        {...getCoverRootProps()}
        sx={{
          border: '2px dashed',
          borderColor: coverArt ? 'success.main' : 'divider',
          borderRadius: 1,
          p: 3,
          textAlign: 'center',
          cursor: 'pointer',
          bgcolor: coverArt ? 'success.light' : 'background.paper',
          '&:hover': {
            borderColor: 'primary.main',
            bgcolor: 'action.hover'
          }
        }}
      >
        <input {...getCoverInputProps()} />
        {coverArt ? (
          <Box sx={{ textAlign: 'center' }}>
            <Box
              component="img"
              src={URL.createObjectURL(coverArt)}
              alt="Cover preview"
              sx={{
                width: '100%',
                maxWidth: 300,
                height: 'auto',
                borderRadius: 1,
                mb: 2
              }}
            />
            <Typography>
              {coverArt.name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Click or drag to replace
            </Typography>
          </Box>
        ) : (
          <>
            <Typography variant="h6" gutterBottom>
              Drop your cover artwork here
            </Typography>
            <Typography color="text.secondary">
              or click to select a file
            </Typography>
            <Typography variant="caption" display="block" sx={{ mt: 1 }}>
              Recommended: Square image, minimum 3000x3000 pixels
            </Typography>
          </>
        )}
      </Box>

      {/* Guidelines */}
      <Box sx={{ mt: 3 }}>
        <Typography variant="subtitle2" gutterBottom>
          Important Guidelines
        </Typography>
        <Typography variant="body2" color="text.secondary">
          • Ensure your artwork is unique and not infringing on any copyrights<br />
          • Avoid text that may be illegible at smaller sizes<br />
          • Consider how your artwork will look at different sizes (playlist, mobile, etc.)<br />
          • Make sure the image is sharp and properly centered
        </Typography>
      </Box>
    </Paper>
  );
};

export default CoverArtwork;